import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  // snackBar: {
  //   paddingTop: '10px',
  // },
}))

export default useStyles
